import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, BookOpen, Clock } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useSEO } from '../hooks/useSEO';

const posts = [
  {
    slug: 'first-week-in-a-faja',
    title: "What to Expect Your First Week in a Faja Colombiana",
    excerpt: "Day 1 to day 7 — the honest timeline of breaking in a real faja. What's normal, what's not, and what changes after the first 48 hours that nobody warns you about.",
    readTime: '5 min read',
    category: 'How-To',
    date: '2026-02-08'
  },
  {
    slug: 'history-of-fajas-colombianas',
    title: "Why Are Fajas Colombianas Specifically So Good? A Brief History",
    excerpt: "Colombian women didn't accidentally invent the best shapewear on earth. It came from a specific industry, a specific need, and decades of refinement. Here's the actual story.",
    readTime: '7 min read',
    category: 'Education',
    date: '2026-02-08'
  },
  {
    slug: 'real-customer-30-day-faja-results',
    title: "What 5 Real Women Said After 30 Days in a Faja Colombiana",
    excerpt: "Marketing copy says one thing. Real wear says another. Here's what five different women — different ages, body types, lifestyles — actually noticed after a month.",
    readTime: '6 min read',
    category: 'Stories',
    date: '2026-02-08'
  },
  {
    slug: 'what-to-wear-under-bodycon-dress',
    title: "What to Wear Under a Bodycon Dress: The Complete Guide",
    excerpt: "The bodycon shows everything. The wrong layer ruins the dress. Here's the exact foundation that makes a bodycon dress look like it was made for your body.",
    readTime: '6 min read',
    category: 'Occasion Guide',
    date: '2026-02-08'
  },
  {
    slug: 'faja-vs-waist-trainer',
    title: "Faja vs Waist Trainer: They're Not the Same Thing",
    excerpt: "TikTok sells you a waist trainer. Influencers wear a faja and call it the same thing. They're not. Here's the actual difference, with no marketing spin.",
    readTime: '5 min read',
    category: 'Buying Guide',
    date: '2026-02-08'
  },
  {
    slug: 'faja-for-travel',
    title: "Faja for Travel: Long Flights, Road Trips, and Vacation Photos",
    excerpt: "Vacations are documented now. A Faja Colombiana is the smartest thing in your carry-on — and not for the reason you'd think.",
    readTime: '5 min read',
    category: 'Lifestyle',
    date: '2026-02-08'
  },
  {
    slug: 'how-to-put-on-a-faja',
    title: "How to Put On a Faja Without the Struggle (Step-by-Step)",
    excerpt: "Your first faja can feel like wrestling a wetsuit. By wear three, it's effortless. Here's the exact technique that gets you there faster — no shoulder strain, no broken hooks.",
    readTime: '5 min read',
    category: 'How-To',
    date: '2026-02-08'
  },
  {
    slug: 'black-vs-nude-faja-color',
    title: "Black vs Nude Faja: Which Color Should You Buy First?",
    excerpt: "It seems like a small decision until you wear the wrong one under a white dress. Here's the actual logic on faja color — and why most women end up owning both.",
    readTime: '4 min read',
    category: 'Buying Guide',
    date: '2026-02-08'
  },
  {
    slug: 'faja-rolls-up-fix',
    title: "Why Your Faja Rolls Up (And How to Fix It)",
    excerpt: "The roll-up is the #1 complaint about every faja, real or fake. Sometimes it's a fit issue. Sometimes it's a technique issue. Here's how to diagnose and fix yours.",
    readTime: '4 min read',
    category: 'How-To',
    date: '2026-02-08'
  },
  {
    slug: 'faja-for-bloating',
    title: "Faja for Bloating: Does Compression Actually Help?",
    excerpt: "Real answer for a real problem. Sometimes a faja helps the bloat. Sometimes it makes it worse. Here's how to know which one applies to you.",
    readTime: '5 min read',
    category: 'Wellness',
    date: '2026-02-08'
  },
  {
    slug: 'can-you-sleep-in-a-faja',
    title: "Can You Sleep in a Faja? (And Why You Probably Shouldn't)",
    excerpt: "The internet's split. Some bloggers say sleep in it for results. Others say it's dangerous. Here's the actual medical answer — and what the smart move is for long-term results.",
    readTime: '5 min read',
    category: 'Wellness',
    date: '2026-02-08'
  },
  {
    slug: 'open-bust-vs-full-body-faja',
    title: "Open-Bust vs Full Body Faja: Which One Should Be Your First?",
    excerpt: "Most women pick the wrong one on the first try, then buy the second one six weeks later. Let's skip that detour with a 30-second answer + the full breakdown.",
    readTime: '6 min read',
    category: 'Buying Guide',
    date: '2026-02-08'
  },
  {
    slug: 'faja-vs-spanx-vs-skims',
    title: "Faja vs Spanx vs Skims: Which One Actually Sculpts?",
    excerpt: "Three brands, three completely different products, three completely different outcomes. The honest comparison nobody wants to write because two of these have massive ad budgets.",
    readTime: '7 min read',
    category: 'Buying Guide',
    date: '2026-02-08'
  },
  {
    slug: 'inside-a-faja-colombiana',
    title: "Inside a Faja Colombiana: The Engineering Behind the Snatch",
    excerpt: "Powernet, latex panels, hook-and-eye closure. Once you understand how a real faja is built, you'll spot fake ones in 5 seconds and stop overpaying.",
    readTime: '8 min read',
    category: 'Education',
    date: '2026-02-08'
  },
  {
    slug: 'best-faja-for-wedding',
    title: "The Best Faja for Your Wedding Day (Hint: It's Open-Bust)",
    excerpt: "The dress shows up after months of fittings. The shoes are perfect. And the wrong faja can undo all of it in 30 seconds. Here's how to pick the right one.",
    readTime: '6 min read',
    category: 'Occasion Guide',
    date: '2026-02-08'
  },
  {
    slug: 'postpartum-faja-truth',
    title: "Postpartum Fajas: What's Real and What's Marketing",
    excerpt: "Half the internet sells you a 'belly band' that burns fat. The other half says it's a scam. Here's what actually works after birth — and what to ignore.",
    readTime: '7 min read',
    category: 'Postpartum',
    date: '2026-02-08'
  },
  {
    slug: 'one-faja-five-outfits',
    title: "One Faja, Five Outfits: From Office to Date Night",
    excerpt: "The most underrated thing about owning one good Faja Colombiana is how many different outfits it makes possible. Here's a real Monday-to-Saturday breakdown.",
    readTime: '6 min read',
    category: 'Lifestyle',
    date: '2026-02-08'
  },
  {
    slug: 'faja-sizing-body-type',
    title: "Faja Sizing by Body Type: Pear, Apple, Hourglass, Athletic",
    excerpt: "The standard size chart doesn't account for shape — only measurements. Here's how to actually choose a faja size that flatters your specific build.",
    readTime: '6 min read',
    category: 'Size Guide',
    date: '2026-02-08'
  },
  {
    slug: 'how-to-wash-a-faja',
    title: "How to Wash and Care for Your Faja (Without Killing the Compression)",
    excerpt: "A real Faja Colombiana lasts years — but only if you treat it right. Here's the exact wash routine that keeps the compression tight and the fabric like new.",
    readTime: '5 min read',
    category: 'Care Guide',
    date: '2026-02-08'
  },
  {
    slug: 'wearing-faja-under-jeans',
    title: "Can You Wear a Faja Under Jeans? (Yes — Here's How)",
    excerpt: "Most women assume a faja is dress-only. The opposite is true. Here's exactly how to wear one under jeans for the cleanest waistband line you've ever had.",
    readTime: '4 min read',
    category: 'How-To',
    date: '2026-02-08'
  },
  {
    slug: 'faja-back-pain',
    title: "Will a Faja Help Lower Back Pain? Honest Answer",
    excerpt: "Half the internet says yes. The other half says marketing hype. Here's what's actually true — what helps, what doesn't, and when to skip it entirely.",
    readTime: '6 min read',
    category: 'Wellness',
    date: '2026-02-08'
  },
  {
    slug: 'faja-vs-shapewear-difference',
    title: "Faja vs Shapewear: What's the Real Difference?",
    excerpt: "Most women confuse fajas with shapewear — and end up disappointed. Here's the truth about how Fajas Colombianas sculpt your silhouette while regular shapewear just smooths.",
    readTime: '5 min read',
    category: 'Buying Guide',
    date: '2026-05-10'
  },
  {
    slug: 'how-to-measure-for-a-faja',
    title: "How to Measure for a Faja Colombiana (Complete Size Guide)",
    excerpt: "Choosing the right faja size is the difference between a snatched silhouette and an uncomfortable squeeze. This step-by-step guide shows you exactly how to measure.",
    readTime: '7 min read',
    category: 'Size Guide',
    date: '2026-05-10'
  },
  {
    slug: 'how-long-to-wear-a-faja',
    title: "How Long Should You Wear a Faja Each Day? (Safety Guide)",
    excerpt: "Can you wear a faja all day? Sleep in one? Wear it during workouts? The complete safety guide based on what Colombian aestheticians actually recommend.",
    readTime: '6 min read',
    category: 'Safety & Wear',
    date: '2026-05-10'
  }
];

export const BlogIndexPage = () => {
  useSEO({
    title: 'Faja Articles & Guides | CurveeForYou Blog',
    description: 'Learn about Fajas Colombianas, sizing, compression levels, and how to wear them safely. Expert guides from CurveeForYou.',
    canonical: 'https://curveeforyou.com/blog'
  });

  return (
    <div className="min-h-screen bg-gradient-to-b from-rose-50/50 to-white">
      <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" data-testid="blog-nav-logo">
              <img
                src="https://customer-assets.emergentagent.com/job_item-landing/artifacts/feqbyn90_Logo%20curveeforyou.png"
                alt="CurveeForYou"
                className="h-20 md:h-24 w-auto"
              />
            </Link>
            <Link to="/">
              <Button variant="outline" className="border-[#7d1f3d] text-[#7d1f3d] hover:bg-[#7d1f3d] hover:text-white" data-testid="blog-back-button">
                <ArrowLeft className="w-4 h-4 mr-2" />
                Back to Shop
              </Button>
            </Link>
          </div>
        </div>
      </header>

      <div className="container mx-auto px-6 py-16 max-w-5xl">
        <div className="text-center mb-14">
          <BookOpen className="w-12 h-12 text-[#7d1f3d] mx-auto mb-4" />
          <h1 className="text-4xl lg:text-6xl font-bold text-[#7d1f3d] mb-4">Faja Guides & Articles</h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Everything you need to know about Fajas Colombianas — sizing, compression, safety, and getting the most out of your purchase.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {posts.map((post) => (
            <Link
              key={post.slug}
              to={`/blog/${post.slug}`}
              data-testid={`blog-card-${post.slug}`}
              className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 p-6 flex flex-col border border-rose-100 hover:border-[#7d1f3d] hover:-translate-y-1"
            >
              <div className="flex items-center gap-2 text-xs text-[#7d1f3d] font-semibold uppercase tracking-wider mb-3">
                <span>{post.category}</span>
                <span>·</span>
                <Clock className="w-3 h-3" />
                <span>{post.readTime}</span>
              </div>
              <h2 className="text-xl font-bold text-gray-900 mb-3 leading-snug">{post.title}</h2>
              <p className="text-gray-600 leading-relaxed flex-1">{post.excerpt}</p>
              <div className="mt-4 text-[#7d1f3d] font-semibold text-sm">Read article →</div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-20 p-10 bg-gradient-to-br from-[#7d1f3d] to-[#5d1729] text-white rounded-2xl shadow-2xl">
          <h3 className="text-2xl md:text-3xl font-bold mb-3">Ready for the Real Thing?</h3>
          <p className="text-rose-100 mb-6 max-w-xl mx-auto">
            Skip the research and get the medical-grade Faja Colombiana that&apos;s snatching waists at 25% off — today only.
          </p>
          <Link to="/">
            <Button className="bg-[#d4af37] hover:bg-[#c49d2a] text-[#5d1729] font-bold px-8 py-6 text-lg" data-testid="blog-cta-shop">
              Shop the Faja — $41.99
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};
